import { render, staticRenderFns } from "./CardSummaryInfo.vue?vue&type=template&id=995a00ec&scoped=true&"
import script from "./CardSummaryInfo.vue?vue&type=script&lang=js&"
export * from "./CardSummaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardSummaryInfo.vue?vue&type=style&index=0&id=995a00ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995a00ec",
  null
  
)

export default component.exports